export default __webpack_public_path__ + "static/media/mahesh_Tech.82d15580.jpg";